/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentPrivacyOption
 */
export interface TournamentPrivacyOption {
    /**
     * Internal key (e.g., PUBLIC, PRIVATE, INVITE_ONLY)
     * @type {string}
     * @memberof TournamentPrivacyOption
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentPrivacyOption
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentPrivacyOption
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentPrivacyOption
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentPrivacyOption
     */
    sortOrder: number;
}

/**
 * Check if a given object implements the TournamentPrivacyOption interface.
 */
export function instanceOfTournamentPrivacyOption(value: object): value is TournamentPrivacyOption {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function TournamentPrivacyOptionFromJSON(json: any): TournamentPrivacyOption {
    return TournamentPrivacyOptionFromJSONTyped(json, false);
}

export function TournamentPrivacyOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentPrivacyOption {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'],
    };
}

export function TournamentPrivacyOptionToJSON(json: any): TournamentPrivacyOption {
    return TournamentPrivacyOptionToJSONTyped(json, false);
}

export function TournamentPrivacyOptionToJSONTyped(value?: TournamentPrivacyOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'description': value['description'],
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
    };
}

